<template>
    <div v-if="sportsData && sportsData.length>0" class="ng-star-inserted">
        <div v-for="(match,m_index) in sportsData" :key="m_index" class="row-my">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="matchname match-details-head">
                            <div class="match-name-h" @click="openSportEventDetailPage(match)">
                                <a> {{ match.event_name }} 
                                    <span v-if="match.inplay" class="inplay-animation-text">In-Play</span>
                                    <span v-if="!match.inplay" class="match-time-and-date">{{ timeConverter(match.event_date) }}</span>
                                </a>
                            </div>
                            <div class="game-bookmaker-icons">
                                <span v-if="match.has_fancy==1" class="game-fancy me-1">F</span>
                                <span class="game-sportbook me-1">S</span>
                                <span v-if="match.has_bookmaker==1" class="game-bookmakers">BM</span>
                            </div>
                            <span v-if="checkIsLogin() && notshowInplay()" class="pin-icons">
                                <a @click="makeFavourite(match,type,m_index)" class="add-pins ng-star-inserted">
                                    <img v-if="match.favourite" src="@/assets/images/pin-green.svg" class="img-fluid">
                                    <img v-else src="@/assets/images/pin-white.svg" class="img-fluid" />
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="col-12" @click="openSportEventDetailPage(match)">
                        <div class="oddsEventlist">
                            <div class="btn-group">
                                <button class="back">{{ match.runners && match.runners[0] && match.runners[0].ex.b[0] ? match.runners[0].ex.b[0].p : '-' }}</button>
                                <button class="lay">{{  match.runners && match.runners[0] && match.runners[0].ex.l[0] ? match.runners[0].ex.l[0].p :'-' }}</button>
                            </div>
                            <div class="btn-group">
                                <button class="back">{{ match.runners && match.runners[2] && match.runners[2].ex.b[0] ? match.runners[2].ex.b[0].p : '-' }}</button>
                                <button class="lay">{{  match.runners && match.runners[2] && match.runners[2].ex.l[0]  ? match.runners[2].ex.l[0].p : '-' }}</button>
                            </div>
                            <div class="btn-group">
                                <button class="back">{{  match.runners && match.runners[1] && match.runners[1].ex.b[0] ? match.runners[1].ex.b[0].p :'-' }}</button>
                                <button class="lay">{{ match.runners && match.runners[1] && match.runners[1].ex.l[0] ? match.runners[1].ex.l[0].p : '-' }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment from "moment";
import api from '../services/api';
import * as apiName from '../services/urls';
import * as varConstants from '@/shared/constants/var-constants';
import { getSportsFavouriteServiceCall } from "@/shared/services/common-services";

export default {
    name: "SportItem",
    props:['sportsData','type'],
    methods: {
        clickOnSportItem() {
            this.$router.push({ name: 'sports-event-detail' });
        },
        checkIsLogin(){
            return this.$store.getters.isAuthenticated;
        },
        timeConverter(datetime) {
            return moment(datetime).format('D MMMM  h:mm A');
        },
        removeFavSport(index) {
            this.sportsData.splice(index, 1);
        },
        makeFavourite(match,pageType,index){
            let data = {
                "match_id": match.event_id,
                "game_type": 0,
            };
            api.post(apiName.MAKE_FAVOURITE , data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        let setFavToLocal = JSON.parse(localStorage.getItem(varConstants.FAV_SPORTS_LIST))
                        let favIndex = setFavToLocal.indexOf(Number(match.event_id));
                        if(favIndex != -1) {
                            setFavToLocal.splice(favIndex, 1);
                        } else {
                            setFavToLocal.push(Number(match.event_id));
                        }
                        localStorage.setItem(varConstants.FAV_SPORTS_LIST,JSON.stringify(setFavToLocal));
                        match.favourite = !match.favourite;
                        this.showSuccessModalFunc(response.data.message);
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.showErrorModalFunc(error.data.message);
                }
            });
        },
        showErrorModalFunc(message) {
            this.$emit('error-modal', message)
        },
        showSuccessModalFunc(message) {
            this.$emit('success-modal', message)
        },
        openSportEventDetailPage(match){
            this.$router.push('/sports-event-detail/' + match.event_id )
        },
        notshowInplay() {
            let routeName = this.$route.name;
            return routeName != 'inplay';
        },
    }
};
</script>